/**
 * @file Festival.
 */

/**
 * Festival functions.
 *
 * Runs js specific to the Festival template.
 */
const vFestival = () => {
	import('../../components/anchor-menu/anchor-menu').then((m) => { m.default(); });
};

if (document.readyState !== 'loading') {
	vFestival();
} else {
	document.addEventListener('DOMContentLoaded', vFestival);
}
